import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormComponentsModule } from "./form-components";

@NgModule({
  imports: [CommonModule],
  providers: [],
  exports: [FormComponentsModule]
})
export class UiKitModule {}
